import { VStack } from "@chakra-ui/react";
export const MyFooter = () => {
    const today = new Date();
    return <VStack as="footer" bg="#222" height="2em" width="100%" children={["TEST"]} color="grey" justify="center">
        <>Astros © {2021}-{ today.getFullYear() }</>
    </VStack>
}